module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-087b4a40.png";